// All content is REAL per the brief. Do not invent additional data.
import posterShopyours from "../assets/poster-shopyours.png";
import riysysImg from "../assets/riysys.jpg";
import amamaImg from "../assets/amama.jpg";

export const IMAGES = {
  heroHome:
    "https://images.unsplash.com/photo-1635279474047-ab3cda78bbe8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxydW53YXklMjBmYXNoaW9ufGVufDB8fHxibGFja19hbmRfd2hpdGV8MTc4NTA3NTk4NXww&ixlib=rb-4.1.0&q=85",
  founder:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/0vvjjb9f_IMG_7508.jpeg",
  founder2:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/zlkuh5y5_IMG_7509.jpeg",
  ada:
    "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/g43qhsrz_AdabyMehar3191.jpg.webp",
  krami:
    "https://images.unsplash.com/photo-1580478491436-fd6a937acc9e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxoaWdoJTIwZmFzaGlvbiUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODUwNzU5ODV8MA&ixlib=rb-4.1.0&q=85",
  riysys: riysysImg,
  amama: amamaImg,
  chapter2:
    "https://images.unsplash.com/photo-1490481651871-ab68de25d43d?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  jenn:
    "https://images.unsplash.com/photo-1487222477894-8943e31ef7b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  contact:
    "https://images.unsplash.com/photo-1469334031218-e382a71b716b?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
};

export const STATS = [
  { value: 100, suffix: "+", label: "Brands Scaled" },
  { value: 30, suffix: "x", label: "Peak ROAS" },
  { value: null, display: "6.3–8.9x", label: "Average ROAS" },
];

export const SERVICES = [
  {
    name: "Performance Marketing",
    desc: "Paid acquisition engineered for fashion. Meta and Google systems built to scale D2C brands to 5x+ ROAS.",
    featured: true,
  },
  {
    name: "Influencer Marketing",
    desc: "Curated creator partnerships that translate cultural relevance into measurable revenue.",
  },
  {
    name: "Social Media Management",
    desc: "A living brand voice across channels, consistent, editorial, and unmistakably yours.",
  },
  {
    name: "Creative & UGC / Campaign Shoots",
    desc: "Scroll-stopping creative and campaign photography produced to sell as beautifully as it looks.",
  },
  {
    name: "Brand Consultation",
    desc: "Positioning, identity and strategy for fashion brands finding their voice from the very first step.",
  },
  {
    name: "360 Degree Marketing",
    desc: "End to end marketing that runs the entire growth engine, from strategy to execution, under one roof.",
  },
  {
    name: "Website Development",
    desc: "Conversion-first storefronts crafted with the polish of a fashion house.",
  },
  {
    name: "Automation through AI",
    desc: "Intelligent systems that remove friction and let strategy scale without limits.",
  },
];

export const FEATURED_WORK = [
  { key: "ada", brand: "ADA by Mehar", stat: "30x", statLabel: "Meta ROAS", image: IMAGES.ada },
  { key: "amama", brand: "Amama Jewels", stat: "20x", statLabel: "Meta ROAS", image: IMAGES.amama },
  { key: "riysys", brand: "RIYSYS", stat: "LFW", statLabel: "London Fashion Week", image: IMAGES.riysys },
];

export const CASE_STUDIES = [
  {
    brand: "ADA by Mehar",
    image: IMAGES.ada,
    stats: [
      { label: "Meta ROAS", value: "30" },
      { label: "Google ROAS", value: "11.3" },
      { label: "AOV", value: "+38%" },
      { label: "International Orders", value: "+25%" },
      { label: "Total Sales", value: "₹3.28Cr+" },
    ],
  },
  {
    brand: "Amama Jewels",
    image: IMAGES.amama,
    stats: [
      { label: "Meta ROAS", value: "20" },
      { label: "Featured In", value: "Cocktail 2" },
    ],
  },
  {
    brand: "On The Racks",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/278aalk6_Ontheracks.png",
    stats: [
      { label: "Meta ROAS", value: "10-12x" },
      { label: "Timeframe", value: "First 30 Days" },
      { label: "Starting Point", value: "Zero Sales" },
    ],
  },
  {
    brand: "En:EM the Label",
    image: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/moi0k3wi_ENEM.png",
    stats: [
      { label: "Meta ROAS", value: "10-12x" },
      { label: "RTO Leakage", value: "Solved" },
      { label: "Starting Point", value: "Zero Sales" },
    ],
  },
];

export const CLIENTS = [
  "ADA by Mehar", "Rahul Mishra", "Manish Malhotra", "Shop&Yours",
  "RIYSYS", "Velvet Heart LA", "Amama Jewels", "Tilsim",
  "Elaraa", "Chiffon & Spice", "Nakhrali", "Chapter 2",
  "Love Viana", "Bluorng", "Frow India", "House of Saga",
  "En:EM the Label", "On The Racks", "Shortbread", "Studio Imsoo",
  "Renu Zaveri Jewelry",
];

export const CLIENT_CATEGORIES = [
  {
    label: "Fashion & Apparel",
    brands: [
      "ADA by Mehar", "Rahul Mishra", "Manish Malhotra", "Shop & Yours", "RIYSYS India",
      "Velvet Heart Los Angeles", "Krami India", "Tilsim by Sagarika", "Nakhrali",
      "Label Saniya Sharma", "Nechi Designs", "Semessta Fashion", "Label Saorsa", "Femi9 by AS",
      "Urth Label", "Liyokki", "Jamun Soda", "Vyb Theory", "Fouroz Official", "Nishorama",
      "Posh Patola", "Chiffon & Spice", "RIHOAS", "Love Viana", "Lune", "Foreverchiquestore",
      "Love Arabellaa", "Hiro", "Pícaro", "Frow India", "House of Saga", "Quirky Tales",
      "Bout to Wear", "Rae", "Banaraswala", "Vaire.in", "Miraz by Noor", "Chapter 2", "Jenn",
      "Nef's", "Luxe & You", "ARCU", "ECOnic", "Ombrello", "Sunfere", "iDiva", "Essgee",
    ],
  },
  {
    label: "Menswear & Streetwear",
    brands: ["Gully Labs", "Bluorng", "Almost Gods", "CHRN", "Jaywalking", "Code Brwn"],
  },
  {
    label: "Jewellery",
    brands: ["Elaraa Jewellery", "Renu Zaveri Jewelry", "Amama Jewels"],
  },
  {
    label: "Perfumes & Fragrance",
    brands: ["Secret Alchemist", "Bellavita", "Nisara Beauty", "Affasci", "Lunaer World"],
  },
  {
    label: "Skincare & Beauty",
    brands: ["Aminu Life", "Solved Labs", "D'You", "52 Sundaze", "Clayco Beauty"],
  },
  {
    label: "Lifestyle",
    brands: ["Hemp Hoppers"],
  },
  {
    label: "Couture & Ready-to-Wear",
    brands: [
      "Anita Dongre", "Tarun Tahiliani", "Kunal Rawal", "Arpita Mehta", "Babita Malkani",
      "Gavin Miguel", "Nandita Mahtani", "Monisha Jaising", "Rocky S", "Mahima Mahajan",
      "Reeti Arneja", "Rimi Nayak", "Rozina Couture", "Realm by Vaishali", "Premya by Manishii",
      "RS by Rippii Sethi", "Farzeen Couture", "Ash Haute Couture", "Amore Couture",
      "Couture Siddharth", "Nitya Biswas", "Sonya Vajifdar", "Vani Vats", "Suman Nathwani",
      "Yashodhara", "Sukriit and Aakriti", "Rishab Sahay", "Natuke by Nilesh Parashar",
      "Moonlord by Sonam Pahuja", "Label Kaleido", "Label Romaa", "Kanelle", "Bloni",
      "Antithesis", "Kalighata", "Sonchiraiya", "Trisavaraa", "Nihiyasha",
    ],
  },
  {
    label: "Contemporary & Lifestyle",
    brands: [
      "Gulabo Jaipur", "Yuvrani Jaipur", "Pink Heritage", "Khinkhwab", "Bindaani", "Raisin",
      "Power Sutra", "Ombre Lane", "Perfectly Average", "Free Sparrow", "Butt Chique", "Kiaayo",
      "Juniper", "Blancora", "Naari", "Naissha", "Siyona", "Sivayaa", "Trend Arrest", "Buena",
      "Kiwi by Musskan", "House of Hiya", "House of Armuse", "House of THL", "Vaaya", "Vasstram",
      "Unniyarcha", "Mimamsa", "White Haathi", "Nochee Vida", "Aroka", "Sassafras", "Stado",
      "Zima Leto", "Mint and Cotton", "Fayon Kids",
    ],
  },
  {
    label: "Fine Jewellery",
    brands: [
      "Antara Jewels", "Art Karat", "Tyaani Fine Jewellery", "Manubhai Jewellers", "Tsara Jewels",
      "Nitaara Jewels", "Rosetta Jewels", "Dyu Fine Jewels", "Dianna Jewelry", "Esme Crystals",
      "Bijoux by Priya", "The Jewel Factor",
    ],
  },
  {
    label: "Accessories, Bags & Footwear",
    brands: [
      "Mio Borsa", "Linos Perros", "Paver England", "Luxoro Formello", "Kasually Klassy",
      "Pasion", "Veruschka", "Chini C", "Proleather", "Niiyaa", "Taroob", "La Carte Blanche",
      "Knotty Tales", "Meera Mahadevia", "Mintsa", "Mon Tesor", "Crimzon", "Blingvine",
    ],
  },
  {
    label: "Beauty, Skincare & Hair",
    brands: ["The Mask Lab", "Hair Drama Co.", "Hair Original", "Schwarzkopf Professional", "Mermade Hair"],
  },
];

export const BUILT_FROM_ZERO_CLIENTS = [
  "En:EM the Label", "On The Racks", "Shortbread", "Studio Imsoo", "Renu Zaveri Jewelry",
];

export const MIDDLE_EAST_CATEGORIES = [
  { label: "Contemporary Fashion", brands: ["Bouguessa", "Illi", "NÓRA", "L'Afshar", "The Giving Movement", "Squatwolf"] },
  { label: "Modest Fashion & Couture", brands: ["Hessa Falasi", "Amato Couture", "Al Mraikn"] },
  { label: "Beauty & Skincare", brands: ["Shiffa", "CTZN Cosmetics", "Izil Beauty", "SMPL Skin", "The Camel Soap Factory"] },
  { label: "Fragrance & Wellness", brands: ["Arcadia by Amna", "Lyfe"] },
  { label: "Jewellery & Accessories", brands: ["Bil Arabi", "Toktam", "Sana Al Maktoum Fine Jewellery", "Karen Wazen Eyewear", "Nine Frames"] },
  { label: "Middle East — Couture & RTW", brands: ["Ayesha Depala", "Ayesha Shoaib Malik", "Color Story", "Curador", "Facil Blanco", "Love From Kara", "Kaiane", "Lilo", "Mohtaram", "Samar Murad", "Hala Al Mamari", "Gemy Maalouf", "Key Couture", "Le Royale", "Sixties Fashion", "Temraza"] },
  { label: "USA", brands: ["Farah Naz", "Hareleen Kaur", "Shop Shashi", "The Dapper Lady", "Rahi", "Meadow", "Belsi"] },
  { label: "UK, Europe & Australia", brands: ["Raishma Couture", "Samaira Ghani", "Belovelife", "Fierce London", "Augustha", "Not Perfect Linen", "Leo and Lin", "Sofia Irina", "We Are Kindred", "Sunseeker", "Selmacilek"] },
];

export const FEATURED_IN = {
  magazines: ["Vogue", "Grazia", "Harper's Bazaar", "Harper's Bazaar Arabia"],
  stockists: ["Aza", "Aashni + Co", "Carma", "Le Mill", "Ensemble", "Ogaan", "Pernia's Pop-Up Shop", "The Collective", "Farfetch", "Net-a-Porter", "Mytheresa", "Harrods"],
};

export const TESTIMONIALS = [
  {
    name: "Mitisha & Navya",
    brand: "En:EM the Label",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/moi0k3wi_ENEM.png",
    quote:
      "We launched with zero sales and no idea where to start. On top of that, RTO was eating into whatever little we made, every order felt like a gamble. Connect.Co built the whole system from scratch, fixed the RTO leakage, and took us from nothing to 10-12x ROAS. It stopped feeling like a gamble and started feeling like a business.",
  },
  {
    name: "Rashi Madhogaria",
    brand: "On The Racks",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/278aalk6_Ontheracks.png",
    quote:
      "We had a product we believed in and absolutely zero sales to show for it. I assumed it would take six months to see anything move. We hit 10-12x ROAS in the first month. That first month changed how I think about what is possible for this brand.",
  },
  {
    name: "Sejal & Sabhya Bhambani",
    brand: "Shop & Yours",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/bi4v8v1z_Shopandyours.png",
    quote:
      "We had burnt our hands with agencies three times before this, and we could never break past 2x ROAS no matter who we hired. We went in sceptical. What was different is they did not force a generic playbook on us, they built an influencer strategy around how our brand actually sells. We are at a stable 4-5x now. Stability is what we had been chasing all along.",
  },
  {
    name: "Naineka Jain",
    brand: "Shortbread",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/xtwy7ra0_Shortbread.png",
    quote:
      "I had never run a single ad in my life and I was terrified of spending money on something I did not understand. I kept putting it off. They walked me through every step without making me feel stupid about it, and we are now at 3-4x ROAS. My only regret is how long I waited.",
  },
  {
    name: "Simran & Masoom",
    brand: "Studio Imsoo",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/uvtorxr5_Imsoo.png",
    quote:
      "Our price point is high, and every person we spoke to told us ads would not work for a brand like ours. We had almost accepted that. Connect.Co proved it wrong. We are at 3x ROAS and reaching customers who actually value what we make, not just people hunting for a discount.",
  },
  {
    name: "Renu Zaveri",
    brand: "Renu Zaveri Jewelry",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/1sbp5nxo_Renu%20Zaveri.png",
    quote:
      "I was creating work I was proud of and nobody was seeing it. That is a hard place to be. The organic growth they have built has completely changed that. My pieces are reaching the right people now, and it is consistent, not a one-off spike.",
  },
  {
    name: "",
    brand: "ADA by Mehar",
    photo: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/3c06s18c_Ada%20by%20Mehar.jpg",
    quote:
      "We came to Connect.Co at 1.2x ROAS after a difficult agency experience, carrying a price point everyone told us was too high for online. They did not ask us to discount. Their 360 degree approach took us to 30x and opened international markets we had not been able to touch. They understood luxury in a way our previous agency simply did not.",
  },
];

export const BUILT_FROM_SCRATCH = [
  { brand: "En:EM the Label", transform: "0 → 10-12x", context: "Zero sales and RTO losses eating every order. We built the system from scratch." },
  { brand: "On The Racks", transform: "0 → 10-12x", context: "Zero sales to double-digit ROAS in the first thirty days." },
  { brand: "Shop & Yours", transform: "0 → 4-5x", context: "Stuck under 2x with three previous agencies. Now stable through influencer-led growth." },
  { brand: "Shortbread", transform: "0 → 3-4x", context: "Had never run a single ad. Now scaling with confidence." },
  { brand: "Studio Imsoo", transform: "0 → 3x", context: "High price point everyone said would not sell online. It sells." },
  { brand: "Renu Zaveri Jewelry", transform: "0 → 3-3.5x", context: "Beautiful work nobody could find. Now growing consistently through organic social." },
  { brand: "ADA by Mehar", transform: "1.2x → 30x", context: "Came to us after a failed agency. Scaled and expanded internationally with our 360 degree method." },
];

export const PROOF = [
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/2j3a2r7o_Ada%20by%20MEHAR%20DASHBOARD.webp", caption: "ADA by Mehar — Meta Ads Performance" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/i987cmxj_Imsoo%20Dashboard.webp", caption: "Studio Imsoo — Campaign Dashboard" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/8xqq7kn6_On%20the%20racks%20dashboard.webp", caption: "On The Racks — First Month Results" },
  { img: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/qip429n7_En%20Em%20after%20Dashboard.webp", caption: "En:EM the Label — Ads Dashboard" },
];

export const VIDEO_TESTIMONIALS = [
  {
    src: "https://customer-assets-cm19k8pv.emergentagent.net/job_styled-strategy/artifacts/2vk74psa_Shop%26Yours%20Testimonial.mp4",
    poster: posterShopyours,
    brand: "Shop&Yours",
    author: "Sejal Bambani",
    role: "Founder",
    context: "End-to-end marketing partner.",
  },
];

export const CONTACT = {
  email: "business@connectcocompany.com",
  whatsapp: "+91 9953080505",
  cities: ["Mumbai", "London", "New York", "Dubai"],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Work", to: "/work" },
  { label: "Clients", to: "/clients" },
  { label: "Contact", to: "/contact" },
];
